import { ConnectProto } from "@racoon/api";

/**
 * A Невывоз job can't go on a route itself: it is re-issued as a new attempt at its
 * order, and that attempt replaces it in the pick. A failed re-issue is left out (the
 * global error toast says why); the rest still go through. Pick order is kept.
 */
export const reissueMissed = async (
  jobs: ConnectProto.Job[],
  reissue: (job: ConnectProto.Job) => Promise<ConnectProto.Job>,
): Promise<ConnectProto.Job[]> => {
  const settled = await Promise.allSettled(
    jobs.map((job) => (job.status === ConnectProto.JobStatus.NOT_COMPLETED ? reissue(job) : job)),
  );
  return settled.flatMap((result) => (result.status === "fulfilled" ? [result.value] : []));
};
